import React from 'react';
import { Divider, Grid } from '@mui/material';
import { CardViewTextRow } from 'ui/viewComponents';
import { isSubscriptionCancelledAction } from '../models/Action';
import { ActionCardBase } from './ActionCardBase';
import { ActionCardModalComponentProps } from './ActionCardModalComponent';
import { titleize } from 'lib/helpers';

const ActionCardSubscriptionCancelled: React.FC<ActionCardModalComponentProps> = ({ action }) => {
    if (!isSubscriptionCancelledAction(action)) {
        return <ActionCardBase action={action} broken />;
    }

    const {
        subscriptionId,
        subscriptionSchemeId,
        cancellationReason,
        cancellationFeedback,
        cancellationComment
    } = action.metadata;

    return (
        <ActionCardBase action={action} showDate>
            <Grid container spacing={1}>
                <Grid item xs={6}>
                    <CardViewTextRow title="Subscription ID" value={subscriptionId} noTransform />
                </Grid>
                <Grid item xs={6}>
                    <CardViewTextRow title="Scheme ID" value={subscriptionSchemeId} noTransform />
                </Grid>

                <Grid item xs={12}>
                    <Divider />
                </Grid>

                {cancellationReason && (
                    <Grid item xs={cancellationFeedback ? 6 : 12}>
                        <CardViewTextRow
                            title="Reason"
                            value={titleize(cancellationReason.replace(/_/g, ' '))}
                        />
                    </Grid>
                )}
                {cancellationFeedback && (
                    <Grid item xs={6}>
                        <CardViewTextRow
                            title="Feedback"
                            value={titleize(cancellationFeedback.replace(/_/g, ' '))}
                        />
                    </Grid>
                )}

                {cancellationComment && (
                    <Grid item xs={12}>
                        <CardViewTextRow title="Comment" value={cancellationComment} />
                    </Grid>
                )}
            </Grid>
        </ActionCardBase>
    );
};

export default ActionCardSubscriptionCancelled;
